// extracted by mini-css-extract-plugin
export var arrow = "SearchHeader-module--arrow--5047a";
export var arrowNo = "SearchHeader-module--arrow_no--7ace3";
export var arrowYes = "SearchHeader-module--arrow_yes--0a0f4";
export var flex = "SearchHeader-module--flex--8c88b";
export var flex1 = "SearchHeader-module--flex_1--28043";
export var flexCenter = "SearchHeader-module--flex_center--dcdf2";
export var flexCenterCol = "SearchHeader-module--flex_center_col--3dc74";
export var flexCol = "SearchHeader-module--flex_col--b7b5b";
export var flexFixCenterCol = "SearchHeader-module--flex_fix_center_col--0bb28";
export var flexFixedCenterCol = "SearchHeader-module--flex_fixed_center_col--12815";
export var preTitle = "SearchHeader-module--preTitle--b950e";
export var rotating = "SearchHeader-module--rotating--64735";
export var searchHeader = "SearchHeader-module--searchHeader--eec46";
export var spin = "SearchHeader-module--spin--367af";
export var spinner = "SearchHeader-module--spinner--0da75";
export var spinnerWrapper = "SearchHeader-module--spinnerWrapper--d49fe";
export var title = "SearchHeader-module--title--9fd36";